<!--大用户 - 大用户数据分析 - 片区分析 -->
<template>
  <div>
    <a-row :gutter="24">
      <a-col :span="16">
        <a-card style="height: 92px">
          <div class="formarea">
            <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
              <a-form-item label="片区">
                <a-select v-model="query.belongingArea" placeholder="请选择片区" style="width: 150px" :allowClear="true">
                  <a-select-option v-for="(value, index) in zoneOptionList" :key="index" :value="value">
                    {{ value }}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="查询时间">
                <a-month-picker v-model="query.selectDate" format="YYYY-MM" value-format="YYYY-MM" placeholder="查询时间"
                  style="width: 180px" />
              </a-form-item>
              <a-form-item label="对比时间">
                <a-month-picker v-model="query.selectComparisonDate" format="YYYY-MM" value-format="YYYY-MM"
                  placeholder="对比时间" style="width: 180px" />
              </a-form-item>
              <a-form-item>
                <a-space>
                  <a-button type="primary" @click="initData">查询</a-button>
                  <a-button @click="resetList">重置</a-button>
                </a-space>
              </a-form-item>
            </a-form>
          </div>
        </a-card>
      </a-col>
      <a-col :span="8">
        <a-card>
          <div class="card">
            <img src="~@/assets/bigusers/picture/u156.png" class="picture" alt="用水户数">
            <div class="databoxs">
              <span>{{ typeConut[1] }}</span>
              <span>居民用水户数</span>
            </div>
            <div class="databoxs">
              <span>{{ typeConut[2] }}</span>
              <span>非居民用水户数</span>
            </div>
            <div class="databoxs">
              <span>{{ typeConut[3] }}</span>
              <span>特种用水户数</span>
            </div>
            <div class="databoxs" style="border: 0px;">
              <span>{{ typeConut[4] }}</span>
              <span>其他用水户数</span>
            </div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card style="margin-top: 20px;">
          <div class="water-analysis">
            <!-- 柱状图：片区用水量分析 -->
            <div ref="barChart" style="height: 350px; width: 100%;"></div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card style="margin-top: 20px;">
          <div class="proportion-analysis">
            <!-- 饼图：片区用水占比分析 -->
            <div ref="pieChart" style="height: 350px; width: 100%;"></div>
          </div>
        </a-card>
      </a-col>
      <a-col :span="24">
        <a-card style="margin-top: 20px;">
          <div>
            <a-button type="primary" @click="exportHandle()" style="margin-bottom: 20px;">导出</a-button>
            <div v-if="!showComparison">
              <a-table ref="table" rowKey="id" size="middle" bordered :columns="columns" :loading="dataListLoading"
                :dataSource="list" :pagination="pagination"
                :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                :scroll="{ y: 200 }"></a-table>
            </div>
            <div v-else>
              <a-row :gutter="16">
                <a-col :span="12">
                  <div
                    style=" text-align: center; border: 1px solid #e8e8e8; border-bottom: none; height: 35px; line-height: 35px;">
                    <h4 style="margin: 0;  font-weight: 600;">查询数据</h4>
                  </div>
                  <a-table ref="table" rowKey="id" size="middle" bordered :columns="columns" :loading="dataListLoading"
                    :dataSource="list" :pagination="pagination"
                    :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                    :scroll="{ y: 200, x: 100 }"></a-table>
                </a-col>
                <a-col :span="12">
                  <div
                    style=" text-align: center; border: 1px solid #e8e8e8; border-bottom: none; height: 35px; line-height: 35px;">
                    <h4 style="margin: 0;  font-weight: 600;">对比数据</h4>
                  </div>
                  <div class="comparison-table">
                    <a-table ref="comparisonTable" rowKey="id" size="middle" bordered :columns="comparisonColumns"
                      :loading="dataListLoading" :dataSource="list" :pagination="pagination"
                      :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
                      :scroll="{ y: 200, x: 100 }"></a-table>
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>

        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import axios from 'axios'
import storage from 'store'
import { ACCESS_TOKEN } from '@/store/mutation-types'
export default {
  name: 'ZoneAnalysisPage',
  data () {
    return {
      query: {
        belongingArea: undefined,
        selectDate: '',
        selectComparisonDate: '',
      },
      needQuery: false,
      showComparison: false, // 新增：控制是否显示对比数据
      typeConut: { 1: 0, 2: 0, 3: 0, 4: 0 },
      columns: [
        { title: '片区名称', dataIndex: 'belongingArea', width: '120px', ellipsis: true },
        { title: '采集时间', dataIndex: 'selectTime', width: '120px' },
        { title: '居民用水', dataIndex: 'householdWater', width: '100px' },
        { title: '非居民用水', dataIndex: 'unHouseholdWater', width: '100px' },
        { title: '特种用水', dataIndex: 'specialWaterUsage', width: '100px' },
        { title: '其他', dataIndex: 'otherWater', width: '100px' },
        { title: '总用水', dataIndex: 'countWater', width: '100px' }
      ],
      comparisonColumns: [
        { title: '片区名称', dataIndex: 'belongingArea', width: '120px', ellipsis: true },
        { title: '采集时间', dataIndex: 'selectTimeSecond', width: '120px' },
        { title: '居民用水', dataIndex: 'unHouseholdWaterSecond', width: '100px' },
        { title: '非居民用水', dataIndex: 'unHouseholdWaterSecond', width: '100px' },
        { title: '特种用水', dataIndex: 'specialWaterUsageSecond', width: '100px' },
        { title: '其他', dataIndex: 'otherWaterSecond', width: '100px' },
        { title: '总用水', dataIndex: 'countWaterSecond', width: '100px' }
      ],
      list: [ // 初始化测试数据
      ],
      dataListLoading: false,
      pagination: false,
      //统计图实例
      barChart: null,
      pieChart: null,
      //通用接口
      getZoneListUrl: '/smart-water-major-users/major/users/user/group/belonging_area/select', //获取片区列表
      zoneOptionList: [], //片区列表
      //本页接口
      queryZoneUrl: '/smart-water-major-users/major/users/user/group/select/belonging_area', //查询片区用水量
      queryZoneTableUrl: '/smart-water-major-users/major/users/user/group/select/belonging_area/count', //查询片区表格数据
      queryCountTypeUrl: '/smart-water-major-users/major/users/user/count/belongingarea', //查询大用户类型数量
      exportDataUrl: 'smart-water-major-users/major/users/user/group/select/belonging_area/count/export', //导出url
      exportFileName: '片区数据.xlsx', //导出名称
      //统计图标准样式
      waterStyle: [
        { name: '用水量', type: 'bar', barWidth: '30%', itemStyle: { color: '#389fff' }, barGap: 1 },
        { name: '对比水量', type: 'bar', barWidth: '30%', itemStyle: { color: '#4cca73' }, barGap: 0 }
      ],
    }
  },
  mounted () {
    this.query.selectDate = this.getCurrentYearMonth()
    this.initData();
    this.getZoneList();

  },
  methods: {
    //设置页面名称
    setSystemName () {
      this.$store.commit('SET_SYSTEMNAME', `${this.$store.getters.userInfo.realName}片区分析`)
    },
    getZoneList () {
      this.$http.get(this.getZoneListUrl).then((res) => {
        this.zoneOptionList = res.data
      })
    },
    //初始化数据
    initData () {
      // 重置对比显示状态
      this.showComparison = false;

      this.$http.get(this.queryZoneUrl, { params: this.query }).then((res) => {
        this.getChartData(res.data)
      })
      this.$http.get(this.queryCountTypeUrl, { params: this.query }).then((res) => {
        this.getCountType(res.data)
      })
      this.$http.get(this.queryZoneTableUrl, { params: this.query }).then((res) => {
        this.list = res.data
        // 查询完成后，如果有对比日期，则显示对比数据
        if (this.query.selectComparisonDate) {
          this.showComparison = true;
        }
      })
    },
    //获取当前年月
    getCurrentYearMonth (now) {
      if (now == null) {
        now = new Date();
      }
      let year = now.getFullYear(); // 如 2024
      let month = now.getMonth(); // 月份从0开始

      // 获取上月数据
      if (month === 0) { // 如果是1月，上月应该是去年12月
        year -= 1;
        month = 12;
      } else {
        month -= 1;
      }

      const monthStr = String(month).padStart(2, '0');
      return `${year}-${monthStr}`; // 如 '2024-06'
    },
    //获取用户分类统计
    getCountType (data) {
      if (data.length == 0) {
        this.typeConut = { 1: 0, 2: 0, 3: 0, 4: 0 }
        return;
      }
      data.forEach(element => {
        this.typeConut[element.waterType] = element.waterTypeCount;
      });
    },
    //获取柱状图统计数据
    getChartData (data) {
      let yData = [];
      let circleData = []; //计算比例值
      data.forEach((item, index) => {
        if (item && typeof item === 'object' && !Array.isArray(item)) {
          let dataList = [
            Number(item.householdWater),
            Number(item.unHouseholdWater),
            Number(item.specialWaterUsage),
            Number(item.otherWater)
          ]
          // 确保 this.waterStyle[index] 是可选的，如果不确定是否存在，可以做保护
          if (index == 0) {
            circleData = dataList
          }
          const style = this.waterStyle[index];
          if (style) {
            yData.push({
              ...style,
              data: dataList
            });
          }
        }
      });
      this.initChart(yData);
      this.initCircle(circleData);
    },
    resetList () {
      this.query = {
        belongingArea: undefined,
        selectDate: this.getCurrentYearMonth(),
        selectComparisonDate: '',
      }
      this.showComparison = false; // 重置对比显示状态
      this.initData();
    },
    initChart (yData) {
      const chartDom = this.$refs.barChart;
      if (this.barChart) {
        this.barChart.dispose(); // 销毁旧的图表实例
      }
      this.barChart = echarts.init(chartDom);

      const barOption = {
        title: {
          text: '片区用水量分析',
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        //鼠标悬停时出现弹窗
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' }
        },
        //图例说明
        legend: {
          icon: 'rect',
          data: ['用水量', '对比水量'],
          bottom: 0,
          itemHeight: 8,
          itemWidth: 8,
          textStyle: {
            fontSize: 12
          }
        },
        //调整绘图区域与容器的边距
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['居民用水', '非居民用水', '特种用水', '其它'],
          axisLabel: { interval: 0 }
        },
        yAxis: {
          type: 'value',
          min: 0,
          splitLine: { // 控制横向网格线
            lineStyle: {
              type: 'dashed', // 设置为虚线
              color: '#ccc',  // 虚线颜色
              width: 1        // 线宽
            }
          },
          axisLine: { show: false }
        },
        series: yData
      };
      this.barChart.setOption(barOption);
    },
    initCircle (yData) {
      const chartDom = this.$refs.pieChart;
      if (this.pieChart) {
        this.pieChart.dispose(); // 销毁旧的图表实例
      }
      this.pieChart = echarts.init(chartDom);

      const pieOption = {
        title: {
          text: '片区用水占比分析',
          left: 'left',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b}: {c} ({d}%)'
        },
        legend: {
          data: ['居民用水', '非居民用水', '特种用水', '其他'],
          orient: 'horizontal',
          bottom: 0,
          icon: 'circle',
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            fontSize: 12
          }
        },
        series: [{
          name: '用水占比',
          type: 'pie',
          radius: '70%',
          center: ['50%', '50%'],
          data: [
            {
              value: yData[0],
              name: '居民用水',
              itemStyle: { color: '#3aa0ff' }
            },
            {
              value: yData[1],
              name: '非居民用水',
              itemStyle: { color: '#36cbcb' }
            },
            {
              value: yData[2],
              name: '特种用水',
              itemStyle: { color: '#4ecb73' }
            },
            {
              value: yData[3],
              name: '其他',
              itemStyle: { color: '#fbd337' }
            }
          ],
          label: {
            show: true,
            formatter: '{b}: {d}%',
            fontSize: 12
          },
          labelLine: {
            length: 10,
            length2: 15,
            smooth: true
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
        ]
      };
      this.pieChart.setOption(pieOption);
    },
    exportHandle () {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}${this.exportDataUrl}`, {
        params: this.query,
        responseType: 'blob',
        headers: {
          'Authorization': storage.get(ACCESS_TOKEN),
          'Accept': 'application/vnd.ms-excel'
        }
      })
        .then(response => {
          console.log('导出响应:', response);
          const blob = response.data;
          // 下载逻辑
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = `片区分析表_${new Date().getTime()}.xlsx`;
          link.click();
          window.URL.revokeObjectURL(url);

          this.$message.success('导出成功');
        })
        .catch(error => {
          console.log('导出失败:', error);
          this.$message.error('下载失败');
        })
        .finally(() => {
          this.resetList();
          this.importLoading = false
        })
    }
  },


}
</script>

<style scoped lang="less">
/deep/ .ant-card-body {
  padding: 15px;
}

.card {
  display: flex;
  align-items: center;
}

.picture {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: block;
  /* 确保图片比例正确 */
  object-fit: cover;
  margin: 0 20px 0 0;
}

.databoxs {
  display: flex;
  flex-direction: column;
  margin-left: 12px;
  text-align: center;
  border-right: 1px solid #d3dbcd;
  height: 55px;
  padding-right: 12px;
}

.databoxs span:first-child {
  display: block;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.databoxs span:last-child {
  display: block;
  font-size: 12px;
  text-align: center;
}

.formarea {
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
}

.formarea .ant-form-item {
  margin-right: 16px;
  margin-bottom: 0;
}

/deep/ .ant-table-thead>tr>th {
  text-align: center;
  background-color: #fafafa;
  /* 表头灰色表头背景 */
}

/deep/ .ant-table-tbody>tr>td {
  text-align: center;
}

.comparison-table {
  /deep/ .ant-table-thead>tr>th {
    text-align: center;
    background-color: #e1ebe4;
    /* 表头灰色表头背景 */
  }
}
</style>